export const FORMAT_DATE = {
  REPEAT_BOOKING_ENDS_ON: 'MMM D, YYYY',
  DATE_WITH_DAY: 'ddd DD MMM YYYY',
  DATE_WITHOUT_DAY: 'DD MMM YYYY',
}
